import { Directive } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { BehaviorSubject, catchError, Observable, of, tap } from 'rxjs';
import { CrudApiService } from '../../core/service/abstract/rest-api.service';
import { DialogParam } from './base-entity-list.service';
import { BaseEntityService } from './base-entity.service';

@Directive()
export abstract class BaseDialogComponent<
  T extends { id: number | null },
  S extends BaseEntityService<T, CrudApiService<T>>,
  C,
  P extends DialogParam
> {
  errors$: Observable<Map<string, string[]> | null> = this.service.getError$();
  entity$: Observable<T | null> = this.service.entity$;

  constructor(
    public data: P,
    public dialogRef: MatDialogRef<C>,
    public service: S
  ) {}

  save(item: T) {
    this.service
      .save({ ...this.data, ...item })
      .pipe(
        tap((result) => {
          this.dialogRef.close(result);
          this.service.clearError$();
        }),
        catchError((err) => {
          if (err.error) {
            this.service.setError$(err.error);
          }
          return of(null);
        })
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.service.clearEntity$();
    this.service.clearError$();
  }
}
